<template>
    <div class="container">
        <Title text="Nuova Dichiarazione" :backArrow="true" :backVue="'pratica/' + nome_pratica + '~' + id_pratica" />
        <b-alert :show="no_file_alert" variant="danger">Per favore caricare un file.</b-alert>
        <div class="form-container">
            <b-form @submit="submit">
                <!-- First row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Data della dichiarazione" label-for="data" class="form-group">
                        <b-form-input
                            id="data"
                            v-model="data_certificazione"
                            required
                            type="date"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <!-- / First row -->
                <!-- Second row -->
                <div class="form-row">
                    <div class="pdf-button-container">
                        <ButtonSecondary type="button" class="pdf-button" :text="'Carica Dichiarazione'" :file_input="true" v-model="dichiarazione" @fileUpload="dichiarazioneUploaded($event)"/>
                    </div>
                </div>
                <!-- / Second row -->
                <!-- Second row -->
                <div class="form-row">
                    <div class="pdf-button-container">
                        <ButtonSecondary type="button" class="pdf-button" :text="'Carica Scheda Tecnica'" :file_input="true" v-model="scheda_tecnica" @fileUpload="stUploaded($event)"/>
                    </div>
                </div>
                <!-- / Second row -->
                <div class="submit-button-container">
                    <b-overlay
                        :show="busy"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="success"
                        class="d-inline-block"
                    >
                        <ButtonPrimary :text="'Carica'" :front_arrow="true" class="submit-button" />
                    </b-overlay>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue';
import ButtonPrimary from '@/components/Button-Primary.vue';
import ButtonSecondary from '@/components/Button-Secondary.vue';
import { mixins } from "@/mixins";

export default {
    name: "CreateCertificazione",
    data () {
        return {
            id_pratica: this.$route.params.id,
            data_certificazione: new Date().toJSON().slice(0,10),
            nome_pratica: this.$route.params.name,
            dichiarazione: null,
            scheda_tecnica: null,
            no_file_alert: false,
            busy: false
        }
    },
    components: {
        Title,
        ButtonPrimary,
        ButtonSecondary
    },
    mixins: [mixins],
    methods: {
        dichiarazioneUploaded: function(file) {
            this.dichiarazione = file;
            this.no_file_alert = false;
        },
        stUploaded: function(file) {
            this.scheda_tecnica = file;
            this.no_file_alert = false;
        },
        submit: function (evt) {
            evt.preventDefault()
            if(this.dichiarazione == null){
                this.no_file_alert = true;
                return
            }
            this.busy = true;
            let formData = new FormData();
            if (this.scheda_tecnica)
                formData.append('scheda_tecnica', this.scheda_tecnica)
            formData.append('id_pratica', this.id_pratica);
            formData.append('data_certificazione', this.data_certificazione);
            formData.append('dichiarazione', this.dichiarazione);
            formData.append('nuova', true);
            this.$axios
            .post(this.$apibase + '/api/certificazioni/create_certificazione/',
                formData,
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token'),
                        'Content-Type': 'multipart/form-data;',
                    }
                }
            )
            .then(()=> {
                this.$store.dispatch('setAlert', {message: "Dichiarazione per la pratica \"" + this.nome_pratica + "\" è stata aggiunta con successo.", type: 'success'});
                this.$router.push('/pratica/' + this.nome_pratica + '~' + this.id_pratica);
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        }
    }    
    
}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
    }
    .form-container{
        padding-top: 10px;
        text-align: left;
    }
    .form-group{
        width: 300px;
    }
    .form-row{
        padding-top:30px;
    }
    .submit-button-container {
        margin-top: 80px;
    }
    .submit-button {
        height: 40px;
        width: 120px;
    }
    .pdf-button-container {
        width: 300px;
        display: block;
    }
    .pdf-button {
        height: 40px;
    }
    .form-description{
        width: 100%;
    }
</style>
